import React, { useState } from 'react'
import AITool from '../components/AITool'
import './CreativeTools.css'

const CreativeTools: React.FC = () => {
  const [activeTool, setActiveTool] = useState('poetry')

  const tools = [
    {
      id: 'poetry',
      name: 'Poetry Generator',
      description: 'Generate beautiful poems in various styles and themes',
      icon: '📜',
      endpoint: '/.netlify/functions/generate-poetry',
      fields: [
        { name: 'theme', label: 'Theme or Topic', type: 'text' as const, placeholder: 'e.g., Love, Nature, Friendship, Loss' },
        { name: 'style', label: 'Poetry Style', type: 'select' as const, options: ['Free Verse', 'Haiku', 'Sonnet', 'Limerick', 'Acrostic', 'Rhyming'] },
        { name: 'mood', label: 'Mood', type: 'select' as const, options: ['Romantic', 'Melancholic', 'Joyful', 'Mysterious', 'Inspiring', 'Nostalgic'] },
        { name: 'length', label: 'Length', type: 'select' as const, options: ['Short (4-8 lines)', 'Medium (8-16 lines)', 'Long (16+ lines)'] }
      ]
    },
    {
      id: 'story',
      name: 'Story Ideas',
      description: 'Generate creative story ideas and character concepts',
      icon: '📚',
      endpoint: '/.netlify/functions/generate-story-ideas',
      fields: [
        { name: 'genre', label: 'Genre', type: 'select' as const, options: ['Fantasy', 'Science Fiction', 'Mystery', 'Romance', 'Horror', 'Adventure', 'Drama', 'Comedy'] },
        { name: 'setting', label: 'Setting (Optional)', type: 'text' as const, placeholder: 'e.g., Medieval castle, Space station, Small town' },
        { name: 'elements', label: 'Key Elements', type: 'textarea' as const, placeholder: 'Describe any specific elements you want in the story' },
        { name: 'type', label: 'Output Type', type: 'select' as const, options: ['Story Plot', 'Character Ideas', 'Setting Ideas', 'All of the Above'] }
      ]
    },
    {
      id: 'art',
      name: 'Art Prompt Generator',
      description: 'Create detailed prompts for AI art generation',
      icon: '🎨',
      endpoint: '/.netlify/functions/generate-art-prompt',
      fields: [
        { name: 'subject', label: 'Subject', type: 'text' as const, placeholder: 'e.g., A cat, A landscape, A portrait' },
        { name: 'style', label: 'Art Style', type: 'select' as const, options: ['Realistic', 'Abstract', 'Impressionist', 'Digital Art', 'Watercolor', 'Oil Painting', 'Sketch', 'Anime'] },
        { name: 'mood', label: 'Mood/Atmosphere', type: 'select' as const, options: ['Peaceful', 'Dramatic', 'Mysterious', 'Bright', 'Dark', 'Vibrant', 'Serene'] },
        { name: 'details', label: 'Additional Details', type: 'textarea' as const, placeholder: 'Any specific details, lighting, composition, or artistic elements' }
      ]
    }
  ]

  return (
    <div className="creative-tools">
      <div className="page-header">
        <h1>Creative Tools</h1>
        <p>Generate poetry, story ideas, and art prompts to spark your creativity</p>
      </div>

      <div className="tools-tabs">
        {tools.map((tool) => (
          <button
            key={tool.id}
            className={`tab-button ${activeTool === tool.id ? 'active' : ''}`}
            onClick={() => setActiveTool(tool.id)}
          >
            <span className="tool-icon">{tool.icon}</span>
            <span className="tool-name">{tool.name}</span>
          </button>
        ))}
      </div>

      <div className="tool-content">
        {tools.map((tool) => (
          <div key={tool.id} className={`tool-panel ${activeTool === tool.id ? 'active' : ''}`}>
            <AITool
              title={tool.name}
              description={tool.description}
              endpoint={tool.endpoint}
              fields={tool.fields}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default CreativeTools 